/* unplugin-vue-components disabled */import script from "./KeyWord.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeyWord.vue?vue&type=script&lang=ts&setup=true"

import "./KeyWord.vue?vue&type=style&index=0&id=f7fc18ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7fc18ee"]])

export default __exports__